import React from 'react';

function Youtube({
  width = '1rem',
  style,
  viewBox = '0 0 14 10',
  className,
  fill = 'currentColor',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3663 1.79522C13.2135 1.21979 12.7633 0.766604 12.1916 0.612808C11.1553 0.333344 7.00004 0.333344 7.00004 0.333344C7.00004 0.333344 2.84481 0.333344 1.80854 0.612808C1.23683 0.766628 0.786566 1.21979 0.633743 1.79522C0.356079 2.83821 0.356079 5.01432 0.356079 5.01432C0.356079 5.01432 0.356079 7.19042 0.633743 8.23342C0.786566 8.80884 1.23683 9.24315 1.80854 9.39694C2.84481 9.67641 7.00004 9.67641 7.00004 9.67641C7.00004 9.67641 11.1553 9.67641 12.1916 9.39694C12.7633 9.24315 13.2135 8.80884 13.3663 8.23342C13.644 7.19042 13.644 5.01432 13.644 5.01432C13.644 5.01432 13.644 2.83821 13.3663 1.79522ZM5.64104 6.99006V3.03857L9.11401 5.01437L5.64104 6.99006Z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}
export default Youtube;
